import axios from "axios";
import config from "../config";
export default {
  createAppointmentForEvent(context, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "scheduler/appointment",
      data: context.addAppointmentPayload,
      method: "POST"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  getAvailabilityForAppointment(context, success, error) {
    console.log(context);
    axios({
      url:
        config.URLS.i5Scheduler +
        "scheduler/availability?eventId=" +
        context.eventID +
        "&month=" +
        context.selectedMonth +
        "&year=" +
        context.selectedYear +
        "&timezone=" +
        context.userTimeZone,
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  getAppointmentsForEvent(context, success, error) {
    console.log(context);
    axios({
      url:
        config.URLS.i5Scheduler +
        "events/" +
        context.eventId +
        "/appointment",
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  }
};
